import { z } from "zod";

export type AiComponentData<T extends { type: string }> = T & Partial<Omit<T, "type">>;

export interface CollapseData {
  type: "collapse";
  title?: string | null;
  content?: string | null;
  level?: "info" | "warning" | "error" | null;
}

export const collapseDataSchema = z.object({
  type: z.literal("collapse"),
  title: z.string().nullable().optional(),
  content: z.string().nullable().optional(),
  level: z.enum(["info", "warning", "error"]).nullable().optional(),
});

export interface ReplaceTextData {
  text?: string;
  update?: string;
  before?: string;
  after?: string;
}

export const replaceTextDataSchema = z.object({
  text: z.string().optional(),
  update: z.string().optional(),
  before: z.string().optional(),
  after: z.string().optional(),
});
